import clientLogApi from '@/api/general/clientLog'

export default {
  install (Vue) {
    Vue.config.errorHandler = function (err, vm, info) {
      // This timeout makes sure that any breadcrumbs are recorded before sending it off
      if (isPlainObject(vm)) {
        // This timeout makes sure that any breadcrumbs are recorded before sending it off
        setTimeout(function () {
          console.log(err)
          let errLog = {
            'error': err == null ? '' : err,
            'info': info,
            'pageData': vm == null ? '' : _formatPageData(vm),
            // 'storeState': JSON.stringify(vm.$store.state),
            // 'storeState': vm == null ? '' : JSON.stringify(vm.$store.state),
            'storeState': _formatPageData(vm.$parent.$parent.$parent) + ' -> ' + _formatPageData(vm.$parent.$parent) + ' -> ' + _formatPageData(vm.$parent),
            'path': vm.$route.fullPath
          }
          console.error(errLog)
          sentVueToServer(errLog)
        })
      }
    }

    // Note this only works during development and is ignored in production.
    Vue.config.warnHandler = function (msg, vm, trace) {
      if (isPlainObject(vm)) {
      // This timeout makes sure that any breadcrumbs are recorded before sending it off
        console.log(msg)
        setTimeout(function () {
          let errLog = {
            'error': msg,
            'pageData': vm == null ? '' : _formatPageData(vm),
            'storeState': _formatPageData(vm.$parent.$parent.$parent) + ' -> ' + _formatPageData(vm.$parent.$parent) + ' -> ' + _formatPageData(vm.$parent),
            'path': vm.$route.fullPath
          }
          console.error(errLog)
          console.error(trace)
          // sentVueToServer(errLog)
        })
      }
    }

    window.onerror = function (message, source, lineno, colno, error) {
      // This timeout makes sure that any breadcrumbs are recorded before sending it off
      setTimeout(function () {
        let errLog = {
          'messsage': btoa(message),
          'source': source,
          'lineNo': lineno,
          'colNo': colno,
          'error': btoa(error)
        }
        console.error(errLog)
        sentScriptToServer(JSON.stringify(errLog))
      })
    }

    function sentVueToServer (errLog) {
      try {
        errLog.error = btoa(errLog.error)
        errLog.pageData = btoa(errLog.pageData)
        errLog.storeState = btoa(unescape(encodeURIComponent(errLog.storeState)))
        clientLogApi.submitVue(errLog, cb => {})
      } catch {
        console.error('call log service error')
      }
    }

    function sentScriptToServer (errLog) {
      try {
        clientLogApi.submitScript(errLog, cb => {})
      } catch {
        console.error('call log service error')
      }
    }

    /**
    * Checks whether given value's type is an object literal
    * {@link isPlainObject}.
    *
    * @param wat A value to be checked.
    * @returns A boolean representing the result.
    */
    function isPlainObject (wat) {
      return Object.prototype.toString.call(wat) === '[object Object]'
    }

    function _formatComponentName (vm) {
      if (vm.$root === vm) {
        return 'root instance'
      }
      var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name
      return ((name ? 'component <' + name + '>' : 'anonymous component') +
          (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')) + ';'
    }

    function _formatPageData (vm) {
      let pageDate = _formatComponentName(vm)
      pageDate += ' propsData: ' + vm.$options.propsData + '; data: ' + vm.$data
      return pageDate
    }
  }
}
